
const digest = 'b9b8d373ebf69c589b417dc0d5eddc470a723ed120f70d5c8df7c577af035989';
const classes = {"button":"_button_1kw2a_1"};
const css = `._button_1kw2a_1 {
  cursor: pointer;
  text-decoration: underline;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  